import React, { useState } from 'react'
import styled from '@emotion/styled'
import { Modal } from '@mantine/core'

import { CDNFileBrowser, K1_URL, K2_URL, K3_URL } from 'src/components/pages/KoreanResourcesPage'
import RedButton from './RedButton'
import { buttonPatternDefaultHangulBlue } from '../styles'

const SoundPacksWrapper = styled.div<{ isMobile?: boolean }>`
  display: grid;
  justify-content: center;
  justify-items: center;
  grid-template-columns: ${(props) => props.isMobile ? 'repeat(1fr)' : 'repeat(3, 1fr)'};
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
    padding: 24px;
    margin-top: 24px !important;
  }
`

const SoundPack = styled.div`
  display: grid;
  justify-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    background-color: white;
    border-radius: 24px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    padding: 24px;
  }
`

const SoundPackText = styled.div`
  text-align: center;
  font-family: 'Tilt Warp';
  font-size: 2.25rem;
  color: #3c4043;
  line-height: 1;
  letter-spacing: 0.0001em;
  margin-bottom: 50px;

  @media (max-width: 1000px) {
    font-size: 2rem;
  }

  @media (max-width: 855px) {
    font-size: 1.8rem;
  }

  @media (max-width: 768px) {
    font-size: 1.75rem;
    margin-bottom: 30px;
  }
`

const ViewButton = styled(RedButton)`
  min-width: 200px;
  background-color: #7bbbff;
  background-image: url(${buttonPatternDefaultHangulBlue});

  &:hover {
    background-color: #7fcaff;
    background-image: url(${buttonPatternDefaultHangulBlue});
  }
`

const DownloadButton = styled.a`
  min-width: 200px;
  background-color: #f1f3f4;
  cursor: pointer;
  border-radius: 24px;
  padding: 10px 24px;
  font-size: 1.5rem;
  font-family: 'Tilt Warp';
  text-align: center;
  background-color: white;
  border: 1px solid #ccc;
  color: #99a;
  text-decoration: none;
  display: inline-block;

  &:hover {
    text-decoration: none;
    color: #7bbbff;
  }
`

const SoundPacks = ({ style, isMobile }) => {
  const [chosenCourse, setChosenCourse] = useState('')

  return (
    <SoundPacksWrapper style={{ ...style }} isMobile={isMobile}>
      {chosenCourse && (
        <Modal
          opened={!!chosenCourse}
          onClose={() => setChosenCourse('')}
          size='xl'
        >
          <CDNFileBrowser url={chosenCourse} onClose={() => setChosenCourse('')} />
        </Modal>
      )}
      <SoundPack>
        <SoundPackText>Korean From Zero! 1<br />Sound Pack</SoundPackText>
        <ViewButton onClick={() => setChosenCourse('kfz1')}>View</ViewButton>
        <DownloadButton download target='_blank' href={K1_URL}>Download</DownloadButton>
      </SoundPack>
      <SoundPack>
        <SoundPackText>Korean From Zero! 2<br />Sound Pack</SoundPackText>
        <ViewButton onClick={() => setChosenCourse('kfz2')}>View</ViewButton>
        <DownloadButton download target='_blank' href={K2_URL}>Download</DownloadButton>
      </SoundPack>
      <SoundPack>
        <SoundPackText>Korean From Zero! 3<br />Sound Pack</SoundPackText>
        <ViewButton onClick={() => setChosenCourse('kfz3')}>View</ViewButton>
        <DownloadButton download target='_blank' href={K3_URL}>Download</DownloadButton>
      </SoundPack>
    </SoundPacksWrapper>
  )
}

export default SoundPacks
